export default {
  en: {
    NAME: 'Name',
    CANCEL_BUTTON_TEXT: 'Cancel',
    ADD_BUTTON_TEXT: 'Add',
    ACKNOWLEDGED: 'Acknowledged',
    API_TOKEN_CREATED_MESSAGE: 'API Access token has been successfully generated',
    API_TOKEN_SUCCESS: 'API Access token created',
    COPY_TOKEN: 'Copy Token',
    CLOSE: 'CLOSE',
    TOKEN_HAS_BEEN_COPIED_TO_CLIPBOARD: 'The token has been copied to clipboard',
    I_HAVE_COPIED_THE_TOKEN: 'I have copied the token',
    YOU_HAVE_TO_COPY_THE_TOKEN: 'Please copy the token before closing this window',
    CREATED_TOKEN_STORE_SAFE_LOCATION_WARNING: 'This is the only time you will see this token, store it in a secure location',
    API_TOKENS_USAGE_HISTORY: 'API Token Usage History',
    API_TOKENS: 'API Access Tokens',
    API_TOKENS_MANAGE: 'Manage API Access Tokens',
    API_TOKENS_SEARCH_PH: 'Search API Access Tokens',
    API_TOKENS_ADD_BUTTON: 'Add API Access Token',
    API_TOKENS_NAME: 'API Access Token Name',
    API_TOKENS_ID: 'API Access Token ID',
    API_TOKENS_TIME: 'Creation Date',
    API_TOKENS_HEADER_NONE: 'You do not have any API Access Tokens',
    API_TOKENS_HEADER_USAGE_NONE: 'This API Access Token has not had any usage',
    API_TOKENS_HEADER_LOADING: 'Loading API Access Tokens',
    API_TOKENS_I_EDIT_ALT: 'Edit API Access Token',
    API_TOKENS_USAGE_DETAILS: 'Token Usage Details',
    API_TOKENS_LAST_IP: 'IP (Last Use)',
    API_TOKENS_LAST_DATE: 'Date (Last Use)',
    API_TOKENS_LAST_RESOURCE: 'Resource (Last Use)',
    API_TOKENS_USAGE: 'API Access Token Usage',
    API_TOKENS_USAGE_DATE: 'Date/Time',
    API_TOKENS_USAGE_RESOURCE: 'Resource',
    API_TOKENS_USAGE_IP: 'IP',
    API_TOKEN_DELETE_MESSAGE: 'The Access Token has been successfully deleted',
    API_TOKEN_CREATE_SUCCESS: 'The API Access has been generated',
    DELETE_MODAL_TITLE: 'Delete API Access Token',
    DELETE: 'Delete',
    DATE_TIME: 'Date/time: ',
    RESOURCE: 'Resource: ',
    IP: 'IP: ',
    NONE_USAGE_TEXT: {
      THE_API_ACCESS_TOKEN: 'The API Access Token ',
      HAS_NOT_BEEN_USED: ', has not been used recently'
    },
    WITH_USAGE_TEXT: {
      ARE_YOU_SURE_YOU_WANT_TO_DELETE: 'Are you sure you want to delete the API Access Token? ',
      HAS_BEEN_LAST_USED_ON: ' has been last used on:'
    }
  }
};